import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    username,
    nickname,
    password,
    verCodeId,
    verifyCode,
    gender = '',
    avatar = '',
    mobile = '',
    email = '',
    province = '',
    city = '',
    country = '',
    address = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.register, {
        username,
        nickname,
        password,
        verCodeId,
        verifyCode,
        gender,
        avatar,
        mobile,
        email,
        province,
        city,
        country,
        address,
    }, options);
    if (error) return { error, status };
    return content || { id: '' };
};
